import * as React from "react";
import {PremiumType, UPFRONT_PAYMENT_THRESHOLD} from "@ferry/journey-services";
import {MtaSuccessModalWording} from "./MtaSuccessModalWording";
import {IFactors} from "./GeneratorInputTypes";
import {EditCarMtaSuccessModalWordingGenerator} from "./EditCarMtaSuccessModalWordingGenerator";
import * as successModals from "../../../../../../components/modals/SuccessModalRenderers";
import {MtaModalWordingParams} from "./MtaModalWordingParams";
import {getAmountWithDecimalDigits} from "../../../../../../CommonFunctions";

export interface IUiState {
    payFullPrice: boolean,
    removedDriverFullName: string;
}

export interface IDriver {
    firstName: string,
    lastName: string;
}

export class EditDriverMtaSuccessModalWordingGenerator {

    public static readonly generateModalWording = (request: MtaModalWordingParams): MtaSuccessModalWording => {

        const factors: IFactors = request.factors;
        const driver: IDriver = request.driver;
        const payFullPrice: boolean = request.payFullPrice;
        const cardNumber: string = request.cardNumber;
        const agreeToReuseCardDetails: boolean = request.agreeToReuseCardDetails;
        const previousMonthlyPremium: any = request.previousMonthlyPremium;
        const instalmentsNotPaidOff: boolean = request.instalmentsNotPaidOff;
        const renewalPremium: any = request.renewalPremium;

        const premiumType: PremiumType = PremiumType[factors.premiumType as keyof typeof PremiumType];

        let modalTitle: React.ReactNode;
        let modalBody: React.ReactNode;

        if (factors.additionalPremium > 0 && (premiumType === PremiumType.annual || payFullPrice)) {
            modalTitle = "Payment was successful";
            const modalBodyContent = (
                <>
                    for <span
                    className="font-weight-semi-bold">changing {driver.firstName} {driver.lastName}'s details.</span>
                </>
            );
            modalBody = successModals.paymentSuccessfulAdditionalPremiumModal(factors.additionalPremium, cardNumber, modalBodyContent, agreeToReuseCardDetails, renewalPremium);
        } else if (factors.additionalPremium > 0 && factors.upfrontPaymentAmount >= UPFRONT_PAYMENT_THRESHOLD && !payFullPrice) {
            modalTitle = "Payment was successful";
            const modalContent = (
                <>
                    for <span
                    className="font-weight-semi-bold">changing {driver.firstName} {driver.lastName}'s details.</span>
                </>
            )
            modalBody = successModals.paymentSuccessfulAdditionalPremiumMonthlyModal(factors.upfrontPaymentAmount, factors.monthlyPaymentSpreadAmount, cardNumber, modalContent, agreeToReuseCardDetails, renewalPremium);
        } else if (factors.additionalPremium > 0 && factors.upfrontPaymentAmount < UPFRONT_PAYMENT_THRESHOLD && !payFullPrice) {
            modalTitle = "Your payment plan has been updated";
            modalBody = successModals.paymentPlanUpdatedAdditionalPremiumModal(factors.monthlyPaymentSpreadAmount, factors.monthlyPremium, previousMonthlyPremium, renewalPremium);
        } else if (factors.amountToRefund > 0 && premiumType === PremiumType.monthly && factors.monthlyPremium !== 0) {
            if (instalmentsNotPaidOff) {
                modalTitle = "Your payment plan has been updated";
            } else {
                modalTitle = "Your refund is on the way";
            }
            modalBody = successModals.paymentPlanUpdatedRefundModal(factors.amountToRefund, factors.monthlyPremium, previousMonthlyPremium, instalmentsNotPaidOff, renewalPremium);
        } else if (factors.amountToRefund > 0) {
            modalTitle = "Your Refund is on the way";
            const modalContent = (
                <>
                    <span
                        className="font-weight-semi-bold">for changing {driver.firstName} {driver.lastName}'s details.</span>
                </>
            )
            modalBody = successModals.paymentSuccessfulRefundModal(factors.amountToRefund, modalContent, renewalPremium);
        } else {
            modalTitle = "All done";
            modalBody = (
                <div>
                    <p className="font-weight-extra-light">
                        We’ve saved your changes, and there’s no extra cost for{" "}
                        <span className="font-weight-semi-bold">changing {driver.firstName} {driver.lastName}'s details.</span>
                    </p>
                    {renewalPremium &&
                        (<div className="font-weight-semi-bold">
                            <p>
                                Your renewal price has also stayed the same at {getAmountWithDecimalDigits(renewalPremium)}&nbsp;
                            </p>
                            <p>
                                Please check your renewal tile for further details
                            </p>
                        </div>)
                    }
                </div>
            );
        }

        return new MtaSuccessModalWording(modalTitle, modalBody, EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalTitle(), EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalBody());
    }
}
